import { ConsultationDetails } from "../model";

export const useHrAndLineManagers = (consultationDetails: ConsultationDetails) => {
    return consultationDetails && [
        consultationDetails.hrNames?.join(", "),
        consultationDetails.lineManagersNames?.join(", ")
    ].filter(n => n).join(" / ");
};

export interface ReportDetails {
    reportChangesBlocked?: boolean;
    releaseReportComments?: string;
    approvalState?: string;
    isConsentWithdrawn?: boolean;
}

export enum ReportApprovalStatusTypes {
    Approved = "Approved",
    ApprovedWithComments = "ApprovedWithComments",
    AutoApproved = "AutoApproved",
    AwaitingApproval = "AwaitingApproval",
    RequestedChanges = "RequestedChanges",
    RequestedChangesByQA = "RequestedChangesByQA",
    Rejected = "Rejected",
    SystemAdminWithdrawn = "SystemAdminWithdrawn"
}

export const consultationMethodOptions = [
    { text: "Telephone", value: "Telephone" },
    { text: "Video", value: "Video" },
    { text: "Face to Face", value: "FaceToFace" }
];

export interface ExtraSection {
    id: string;
    title: string;
    content: React.ReactNode;
}
